export const STORY_POINTS = [
  { value: '0', label: 'No effort', description: 'Already complete or virtually no work.' },
  { value: '1', label: 'Very small & trivial', description: 'A familiar, simple task with no unknowns. A useful reference story.' },
  { value: '2', label: 'Small & routine', description: 'A little more work, with clear requirements and a familiar solution.' },
  { value: '3', label: 'Medium', description: 'A normal, well-defined story with moderate work and a clear approach.' },
  { value: '5', label: 'Large', description: 'Noticeable effort, with some complexity, unknowns or dependencies.' },
  { value: '8', label: 'Very large & complex', description: 'Significant complexity or risk. The largest story to plan into one sprint.' },
  { value: '13', label: 'Epic — split before a sprint', description: 'Too large or uncertain for one sprint. Break it into smaller stories.' },
  { value: '20', label: 'Huge', description: 'A whole feature or module that needs more design and refinement.' },
  { value: '40', label: 'Huge / incomplete', description: 'A large area of work with fundamental decisions still missing.' },
  { value: '100', label: 'Complete unknown', description: 'Start with research or a spike to understand the problem.' },
  { value: 'coffee', label: 'Break needed', description: 'A planning-poker pause. This is not a numeric estimate.' },
  { value: 'unknown', label: 'Needs clarification', description: 'Requirements or important information are missing. This is not a numeric estimate.' },
] as const;

export type StoryPoints = typeof STORY_POINTS[number]['value'];
export const NUMERIC_STORY_POINTS = STORY_POINTS.filter((item) => /^\d+$/.test(item.value)).map((item) => item.value);
export const MAX_EFFORT_MINUTES = 52_560_000;
export const storyPointsSymbol = (value: string) => value === 'coffee' ? '☕' : value === 'unknown' ? '❓' : value;

export function effortInput(minutes: number | null | undefined): string {
  return minutes == null ? '' : `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}

/** Blank means unset/automatic; bare numbers are decimal hours, consistent with Mantis note entry. */
export function parseEffortMinutes(input: string): number | null {
  const text = input.trim().replace(',', '.');
  if (!text) return null;
  const clock = /^(\d+):([0-5]\d)$/.exec(text);
  const minutes = clock ? Number(clock[1]) * 60 + Number(clock[2])
    : /^\d+(?:\.\d+)?$/.test(text) ? Math.round(Number(text) * 60) : NaN;
  if (!Number.isSafeInteger(minutes) || minutes < 0 || minutes > MAX_EFFORT_MINUTES) throw new Error('Enter effort as H:MM or decimal hours.');
  return minutes;
}
